import { Grid, IconButton, Typography } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router-dom";
import { ordersStyles } from "../styles/ordersStyles";

const PageNotFound = () => {
  const classes = ordersStyles();
  const history = useHistory();
  return (
    <Grid
      container
      justifyContent="center"
      spacing={2}
      className={classes.orderRoot}
    >
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        spacing={1}
        direction="column"
        xs={12}
        style={{
          backgroundColor: "white",
          boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          borderRadius: "3px",
          height: "20vh",
        }}
      >
        <Typography variant="body1">
          {" "}
          متاسفانه صفحه مورد نظر پیدا نشد{" "}
        </Typography>
        <Typography variant="body1">بازگشت به صفحه نخست</Typography>
        <IconButton color="primary" onClick={() => history.push("/")}>
          <Refresh fontSize="large" />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default PageNotFound;
